// src/utils/tokenManager.ts

const ACCESS_TOKEN_KEY = "authToken";
const ACCESS_EXPIRE_KEY = "accessExpire";
const REFRESH_TOKEN_KEY = "refreshToken";
const REFRESH_EXPIRE_KEY = "refreshExpire";
const USER_CODE_KEY = "userCode";

// Token'ı kaydet
export const saveTokenData = ({
  accessToken,
  accessExpire,
  refreshToken,
  refreshExpire,
  userCode,
}: {
  accessToken: string;
  accessExpire: string;
  refreshToken: string;
  refreshExpire: string;
  userCode: string;
}) => {
  localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
  localStorage.setItem(ACCESS_EXPIRE_KEY, accessExpire);
  localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  localStorage.setItem(REFRESH_EXPIRE_KEY, refreshExpire);
  localStorage.setItem(USER_CODE_KEY, userCode);
};

export const saveTokenDataRefresh = ({
  accessToken,
  accessExpire,
}: {
  accessToken: string;
  accessExpire: string;
}) => {
  localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
  localStorage.setItem(ACCESS_EXPIRE_KEY, accessExpire);
};

// Token'ı al
export const getAccessToken = (): string | null => {
  return localStorage.getItem(ACCESS_TOKEN_KEY);
};

export const setAccessToken = (token: string): void => {
  localStorage.setItem(ACCESS_TOKEN_KEY, token);
};

// Refresh Token'ı al
export const getRefreshToken = (): string | null => {
  return localStorage.getItem(REFRESH_TOKEN_KEY);
};

export const setRefreshToken = (token: string): void => {
  localStorage.setItem(REFRESH_TOKEN_KEY, token);
};

// User Code'u al
export const getUserCode = () => localStorage.getItem(USER_CODE_KEY);

// Token geçerli mi kontrol et
export const isAccessTokenValid = () => {
  const expireTime = localStorage.getItem(ACCESS_EXPIRE_KEY);
  if (!expireTime) return false;
  return new Date(expireTime).getTime() > Date.now();
};

export const canAttemptAccessRefresh = (): boolean => {
  const expStr = localStorage.getItem(ACCESS_EXPIRE_KEY);
  if (!expStr) return false; // expire yoksa refresh deneme
  const expMs = Date.parse(expStr); // ISO 8601 ise UTC olarak parse edilir
  if (Number.isNaN(expMs)) return false;

  const nowMs = Date.now(); // UTC epoch ms
  return expMs <= nowMs;
};

// Logout işlemi (tokenları sil)
export const clearTokenData = () => {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(ACCESS_EXPIRE_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  localStorage.removeItem(REFRESH_EXPIRE_KEY);
  localStorage.removeItem(USER_CODE_KEY);
};

export const clearTokens = (): void => {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
};
